// extracted by mini-css-extract-plugin
var _1 = "MenuToggle__MenuToggle___w7cgM";
var _2 = "MenuToggle__dark___kZyCq";
var _3 = "MenuToggle__icon___gqBN6";
var _4 = "MenuToggle__text___n9Wak";
var _5 = "MenuToggle__wiggle___MLcD_";
export { _1 as "MenuToggle", _2 as "dark", _3 as "icon", _4 as "text", _5 as "wiggle" }
